import { OvertimeReason } from "./overtimeReason";

export interface LiquidatedOvertimeHourModel {
    preliquidationHourSummaryId: number;
    date: string;
    fullName: string;
    hourTypeId: number;
    workshiftName: string;
    employeeId: number;
    employeeDocument: string;
    abbreviation: string;
    hour: number;
    minute: number;
    modifiedHour: number | null;
    modifiedMinute: number | null;
    status: HourSummaryStatesEnum | null;
    descriptionStatus: string;
    currentStatus: HourSummaryStatesEnum | null;
    descriptionCurrentStatus: string;
    comments: string;
    approvalFlowName: string;
    usersApprovalFlows: UserApprovalFlow[];
    startDate: string;
    endDate: string;
    overtimeReason: OvertimeReason;
}

export interface UserApprovalFlow {
    userId: number;
    userName: string;
    stage: number;
    status: HourSummaryStatesEnum | null;
    descriptionStatus: string;
}

export enum HourSummaryStatesEnum {
    Draft = 0,
    Review = 1,
    Approved = 2,
    Rejected = 3,
    Undefined = 4,
}
